import React from "react";
import { Link } from "react-router-dom";

export const Navigation = (props) => {
  const closeMobileNav = () => {
    const navMenu = document.getElementById("bs-example-navbar-collapse-1");
    const toggleButton = document.querySelector(
      '[data-target="#bs-example-navbar-collapse-1"]'
    );

    if (navMenu && navMenu.classList.contains("in")) {
      navMenu.classList.remove("in");
      navMenu.setAttribute("aria-expanded", "false");
    }

    if (toggleButton) {
      toggleButton.classList.add("collapsed");
      toggleButton.setAttribute("aria-expanded", "false");
    }
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-label="Toggle navigation"
            aria-controls="bs-example-navbar-collapse-1"
            aria-expanded="false"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <Link
            className="navbar-brand page-scroll navbar-brand-wrap"
            to="/"
            onClick={closeMobileNav}
          >
            <img
              src="/img/Hamilton_Transparent_Logo.png"
              alt="Hamilton Pressure Washing logo"
              className="navbar-brand-logo"
              width="240"
              height="240"
            />
            <span className="navbar-brand-text">Hamilton Pressure Washing</span>
          </Link>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <Link to="/about" className="page-scroll" onClick={closeMobileNav}>
                About
              </Link>
            </li>
            <li>
              <Link to="/services" className="page-scroll" onClick={closeMobileNav}>
                Services
              </Link>
            </li>
            <li>
              <Link to="/service-areas" className="page-scroll" onClick={closeMobileNav}>
                Areas
              </Link>
            </li>
            <li>
              <Link to="/gallery" className="page-scroll" onClick={closeMobileNav}>
                Gallery
              </Link>
            </li>
            <li>
              <Link
                to="/testimonials"
                className="page-scroll"
                onClick={closeMobileNav}
              >
                Testimonials
              </Link>
            </li>
            <li>
              <Link to="/contact" className="page-scroll" onClick={closeMobileNav}>
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
